import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { WEEKDAYS, WEEKDAY_COLORS, getVisitsForDateAndAssignee, VisitCell } from "./reportHelpers";

export const ResourceReport = ({ weekDates, weekTitle, activeUsers, visits, users, studies, onVisitClick }) => (
  <Card className="border-0 shadow-lg mb-8" data-testid="resource-report">
    <CardHeader><CardTitle className="text-xl font-bold text-gray-900 mb-4">{weekTitle}</CardTitle></CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-purple-500 to-blue-500 text-white">
              <th className="border border-gray-300 p-3 text-left font-medium w-32">Resource</th>
              {weekDates.map((date, i) => (
                <th key={`res-${date.toISOString()}`} className="border border-gray-300 p-3 text-center font-medium min-w-48">
                  <div className={`font-bold ${WEEKDAY_COLORS[i]}`}>{WEEKDAYS[i]}</div>
                  <div className="text-sm font-normal">{date.getDate()}-{date.toLocaleDateString('en-US', { month: 'short' })}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {activeUsers.map((user, userIndex) => (
              <tr key={user.id} className={userIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                <td className="border border-gray-300 p-3 font-medium text-gray-900">{user.name.split(' ')[0]}</td>
                {weekDates.map((date) => {
                  const userVisits = getVisitsForDateAndAssignee(date, user.name, users, visits);
                  return (
                    <td key={`res-${user.id}-${date.toISOString()}`} className="border border-gray-300 p-2 align-top">
                      <div className="space-y-1">
                        {userVisits.map(v => (
                          <VisitCell
                            key={v.id || `${v.patient_name}-${v.visit_type}`}
                            visit={v}
                            studies={studies}
                            onClick={() => onVisitClick(v)}
                          />
                        ))}
                        {userVisits.length === 0 && <div className="text-gray-400 text-xs text-center py-2">-</div>}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
